import { Component, OnInit } from '@angular/core';
import { FreemiumService } from '../freemium.service';

@Component({
    selector: 'app-webbtree-talent-insights',
    templateUrl: './webbtree-talent-insights.component.html',
    styleUrls: ['./webbtree-talent-insights.component.scss'],
    standalone: false
})
export class WebbtreeTalentInsightsComponent implements OnInit {
  showInsightsSection: boolean = false;
  constructor(private freemiumService: FreemiumService) { }

  ngOnInit() {
    this.freemiumService.getInsightsProfileSection.subscribe(res=>this.showInsightsSection = res);
  }

}
